export enum TaskVariableAreaView {
  'FORM' = 'FORM',
  'CHECK_LIST' = 'CHECK_LIST',
  'INTERVENTION' = 'INTERVENTION',
  'ACTIVITY_HISTORY' = 'ACTIVITY_HISTORY',
  'ACTION_EXECUTION_LOGS' = 'ACTION_EXECUTION_LOGS',
  'COMMENTS' = 'COMMENTS',
}
